var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "batch-set" },
    [
      _c(
        "el-table",
        { staticClass: "table", attrs: { data: _vm.tableData } },
        [
          _c("el-table-column", {
            attrs: { label: "规格图片", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      scope.row.attrImage
                        ? _c("img", {
                            staticClass: "attr-img pointer",
                            attrs: { src: scope.row.attrImage },
                            on: {
                              click: function ($event) {
                                return _vm.attrImage(scope.row)
                              },
                            },
                          })
                        : _c("i", {
                            staticClass:
                              "el-icon-camera cameraIconfont pointer",
                            on: {
                              click: function ($event) {
                                return _vm.attrImage(scope.row)
                              },
                            },
                          }),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "主图管理", align: "center", "min-width": "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleMainImage(scope.row)
                          },
                        },
                      },
                      [_vm._v("主图管理")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "SKU名称", align: "center", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { size: "mini" },
                      model: {
                        value: scope.row.skuName,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "skuName", $$v)
                        },
                        expression: "scope.row.skuName",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "条形码", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { size: "mini" },
                      model: {
                        value: scope.row.barCode,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "barCode", $$v)
                        },
                        expression: "scope.row.barCode",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "原价", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { size: "mini", controls: false },
                      model: {
                        value: scope.row.otPrice,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "otPrice", $$v)
                        },
                        expression: "scope.row.otPrice",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "代发成本价", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { size: "mini", controls: false },
                      model: {
                        value: scope.row.supplyPrice,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "supplyPrice", $$v)
                        },
                        expression: "scope.row.supplyPrice",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "集采供货价", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { size: "mini", controls: false },
                      model: {
                        value: scope.row.cpSupplyPrice,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "cpSupplyPrice", $$v)
                        },
                        expression: "scope.row.cpSupplyPrice",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "集采起订量", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { size: "mini", controls: false },
                      model: {
                        value: scope.row.cpMinQuantity,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "cpMinQuantity", $$v)
                        },
                        expression: "scope.row.cpMinQuantity",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "库存数量", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { size: "mini", controls: false },
                      model: {
                        value: scope.row.stock,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "stock", $$v)
                        },
                        expression: "scope.row.stock",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "库存预警量", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { size: "mini", controls: false },
                      model: {
                        value: scope.row.stockWarning,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "stockWarning", $$v)
                        },
                        expression: "scope.row.stockWarning",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "采销状态", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "mini" },
                        on: {
                          change: function ($event) {
                            return _vm.changeCpStatus(scope.$index)
                          },
                        },
                        model: {
                          value: scope.row.cpStatus,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "cpStatus", $$v)
                          },
                          expression: "scope.row.cpStatus",
                        },
                      },
                      _vm._l(_vm.cpStatusEnum, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "上下架状态", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "mini" },
                        on: {
                          change: function ($event) {
                            return _vm.changeListStatus(scope.$index)
                          },
                        },
                        model: {
                          value: scope.row.listStatus,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "listStatus", $$v)
                          },
                          expression: "scope.row.listStatus",
                        },
                      },
                      _vm._l(_vm.goodsStatusEnum, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                label: "操作",
                align: "center",
                width: "160",
                fixed: "right",
              },
            },
            [
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.batchAdd },
                  },
                  [_vm._v("批量添加")]
                ),
              ],
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("MainImageVue", {
        ref: "mainImageRef",
        on: { mainImageList: _vm.mainImageList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }